import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { request } from 'arts/../shared/request';
import WorkListItem from 'arts/components/WorkListItem';
import * as styles from './styles.module.scss';

const WIDGET_LIMIT = 6;

const CmsWorksWidget = ({ slug }) => {
  const [works, setWorks] = useState(null);

  useEffect(() => {
    request(`/api/landing_tags/${ encodeURIComponent(slug) }`)
      .then((data) => setWorks((data.works || []).slice(0, WIDGET_LIMIT)))
      .catch(() => setWorks([]));
  }, [slug]);

  if (!works || works.length === 0) return null;

  const onItemClick = () => {};

  return (
    <ul className={ styles.grid }>
      {
        works.map((w, index) => (
          <WorkListItem
            data={ w }
            key={ w.id }
            loading={ false }
            position={ index }
            onClick={ onItemClick }
            skipAsyncLoading
          />
        ))
      }
    </ul>
  );
};

CmsWorksWidget.propTypes = {
  slug: PropTypes.string.isRequired
};

export default CmsWorksWidget;
